<article class="user-ads-datatable">
  <table mat-table [dataSource]="dataSource" class="mat-table-container">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Nom</th>
      <td mat-cell *matCellDef="let element">{{ element.name }}</td>
    </ng-container>
    <ng-container matColumnDef="media">
      <th mat-header-cell *matHeaderCellDef>Média</th>
      <td mat-cell *matCellDef="let element">{{ element.media }}</td>
    </ng-container>
    <ng-container matColumnDef="support">
      <th mat-header-cell *matHeaderCellDef>Support</th>
      <td mat-cell *matCellDef="let element">{{ element.support }}</td>
    </ng-container>
    <ng-container matColumnDef="timeSlot">
      <th mat-header-cell *matHeaderCellDef>Tranche horaire</th>
      <td mat-cell *matCellDef="let element">{{ element.timeSlot }}</td>
    </ng-container>
    <ng-container matColumnDef="broadcastDate">
      <th mat-header-cell *matHeaderCellDef>Date de diffusion</th>
      <td mat-cell *matCellDef="let element">{{ element.broadcastDate }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      (click)="openAddDialog()"
      class="user-ads-datatable__table-line"
    ></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length">
        Aucune donnée disponible
      </td>
    </tr>
  </table>
</article>
